import React, { Component } from 'react';
export class Archivo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombreArchivo: null
        };
    }
    obtenerValorArchivo = (event) => {
        let { cambio } = this.props;
        let nombreArchivo=event.target.files[0].name;
        this.setState({nombreArchivo:nombreArchivo});
        cambio(event);
    }
    render() {
        let { id ,nombre, etiqueta, aceptar } = this.props;
        let { nombreArchivo } = this.state;

        return (<div>
            <span className="p-button p-fileupload-choose p-component p-button-text-icon-left">
                <span className="p-button-icon-left pi pi-plus">
                </span>
                <label for={id} className="p-button-text">{etiqueta}</label>
                <input id={id} name={nombre} style={{ visibility: "hidden" }} type="file" onChange={this.obtenerValorArchivo} accept={aceptar} />
            </span>
            <span>
                {nombreArchivo ? <div><br /> <span><i className="pi-md-check"></i>Archivo seleccionado: {nombreArchivo}</span> </div> : null}
            </span>
        </div>);
    }
}